import React from 'react'
import 'swiper/css'
import { AboutBrands } from './Brands'

const AboutSection = () => {
  const pluses = [
    'Centrum plików',
    'Listy wyposażenia i produktów',
    'Kosztorys prac wykończeniowych',
    'Efektywna Komunikacja',
    'Harmonogram działań',
    'Zadania'
  ]

  return (
    <section className='tw-pt-20 md:tw-pt-28 xl:tw-pt-32 tw-pb-0'>
      <div className='tw-container xl:tw-max-w-7xl tw-mx-auto tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-14 tw-gap-y-8 lg:tw-gap-y-0 px-4 lg:px-0'>
        <div className='tw-flex tw-flex-col'>
          <div className='tw-flex tw-items-center tw-gap-x-4 md:tw-gap-x-6 xl:tw-gap-x-8'>
            <div className='tw-h-0.5 tw-w-8 md:tw-w-10 tw-bg-green' />
            <h2 className='tw-text-green tw-text-xs md:tw-text-sm xl:tw-text-base tw-font-semibold'>Jedno narzędzie, pełna kontrola!</h2>
          </div>

          <h3 className='tw-mt-4 md:tw-mt-8 tw-text-xl md:tw-text-2xl xl:tw-text-3xl tw-font-semibold'>
            Nasza platforma to kompleksowe narzędzie, które zapewni Ci pełną kontrolę nad każdym etapem realizacji projektu
          </h3>
        </div>

        <p className='md:tw-my-auto tw-text-sm md:tw-text-base tw-tracking-wide tw-font-medium tw-text-center lg:tw-text-left'>
          Zyskaj przejrzysty wgląd w pracę nad projektem. Kontaktuj się ze współpracownikami, podwykonawcami oraz klientami w czasie rzeczywistym.
          <br /><br />
          Twórz zadania, harmonogram maksymalizując produktywność. Nasze intuicyjne narzędzie pozwala na szybki dostęp do wszystkich informacji, eliminując chaos i zwiększając efektywność pracy.
        </p>
      </div>

      <div className='tw-mt-12 lg:tw-mt-16 xl:tw-mt-20 tw-relative'>
        <div className='tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-36 xl:tw-h-48 tw-w-full tw-bg-white lg:tw-bg-gray' />

        <div className='tw-container xl:tw-max-w-7xl tw-mx-auto tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-14 px-4 lg:px-0'>
          <div className='tw-w-full tw-h-fit tw-z-10 tw-relative'>
            <img src='assets/images/icons/Zdjecie na główną  (te największe).jpg' alt='about' className='tw-rounded-md tw-overflow-hidden' />

            <div className='tw-bg-green tw-absolute tw-bottom-10 tw-left-1/2 -tw-translate-x-1/2 tw-p-2 md:tw-p-4 xl:tw-p-6 tw-rounded-sm'>
              <a
                href='https://www.youtube.com/watch?v=nrJtHemSPW4'
                target='_blank'
                rel='noopener noreferrer'
                className='tw-flex tw-items-center tw-gap-x-2'
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'
                  stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'
                  className=''
                >
                  <path
                    d='M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17'
                  />
                  <path d='m10 15 5-3-5-3z' />
                </svg>
                <span className='tw-text-white tw-font-semibold tw-text-xs md:tw-text-sm'>Zobacz funkcje aplikacji!</span>
              </a>
            </div>
          </div>

          <div className='tw-mt-10 xl:tw-mt-20 tw-z-10'>
            <ul className='tw-grid tw-grid-cols-2 tw-gap-x-6 tw-gap-y-2'>
              {pluses.map((item, index) => (
                <li key={index} className='tw-flex tw-items-center tw-gap-x-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='#47a145'
                    stroke='#ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'
                    className='tw-min-h-6 tw-min-w-6'
                  >
                    <circle cx='12' cy='12' r='10' />
                    <path d='m9 12 2 2 4-4' />
                  </svg>
                  <span className='tw-text-xs md:tw-text-sm tw-font-semibold tw-text-teal'>{item}</span>
                </li>
              ))}
            </ul>

            <AboutBrands />
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection
